<template>
    <v-container fill-height fluid>
        <v-row align="center" justify="center">
            <v-col>
                <div
                    class="mx-auto"   
                >
                    <v-list-item three-line style="padding:50px">
                        <v-img
                            src="img/logo.png" 
                        ></v-img>    
                    </v-list-item> 
                    <v-list-item three-line :style="heightTop">
                        <v-row>
                            <v-col
                                cols="12"
                                sm="12"
                                style="margin-bottom:-25px"
                            >
                                <v-text-field
                                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                    :type="show  ? 'text' : 'password'"
                                    outlined
                                    rounded
                                    clearable
                                    label="Senha"
                                    @click:append="show = !show"
                                    v-model="password"
                                ></v-text-field>
                            </v-col>
                            <v-col
                                offset="3"
                                style="margin-bottom:25px"
                            >
                                <span @click="forgotMyPassword">Esqueci minha senha</span>
                            </v-col>
                        </v-row>
                    </v-list-item>
                    <v-card-actions :style="heightBottom">
                        <v-row>
                            <v-col
                                cols="12"
                                sm="12"
                            >
                                <v-btn
                                    depressed
                                    color="primary"
                                    rounded
                                    block
                                    style="color:white"
                                    @click="next"
                                >
                                    Próximo
                                </v-btn>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="12"
                            >
                                <v-btn
                                    color="#f5f5f5 !important"
                                    depressed
                                    rounded
                                    block
                                    @click="back"
                                >
                                    Voltar
                                </v-btn>
                            </v-col>
                            <v-col
                            cols="12"
                            sm="12"
                            align="right" 
                            style="color:#378bac;"
                        >
                                <h6 >by Plataforma SIG</h6>  
                                    </v-col>
                        </v-row>
                    </v-card-actions>
                </div>
            </v-col>
        </v-row>
        <v-dialog
            v-model="dialog"
            max-width="290"
        >
            <v-card>
                <v-card-title class="headline">
                    {{title}}
                </v-card-title>

                <v-card-text>
                    {{message}}
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                        color="green darken-1"
                        text
                        @click="dialog = false"
                    >
                        Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import CrudService from '../../services/CrudService';

export default {
    data: () => ({
        heightTop: "margin-top:100px",
        heightBottom: "padding-bottom:50px",
        show: false,
        password: '',
        title: '',
        message: '',
        dialog: false
    }),

    created(){
        let loginData = JSON.parse(localStorage.getItem("loginData"));

        if(loginData != null)
        {
            let canDemands = loginData.permissionAndMenu.find(permission => {
                return permission.menuId == 27
            });

            if(!(canDemands != null || loginData.userData.userType == 2))
                this.$router.push('menu');
            else
                this.$router.push('kpis');
        }
    },

    methods: {
        async next(){
            if(this.password == ''){
                this.title = "Dados Inválidos";
                this.message = "Informe a senha.";
                this.dialog = true;
            }
            else{
                let loader = this.$loading.show();

                try
                {
                    let crudService = new CrudService();
                    let loginRequest = {
                        email: this.$route.params.login, 
                        signatureId: this.$route.params.signature,
                        password: this.password
                    };

                    let result = await crudService.post(`auth/login`, loginRequest);
                    
                    if(result.status == 200){
                        localStorage.setItem("loginData", JSON.stringify(result.data));
                        loader.hide();

                        let canDemands = result.data.permissionAndMenu.find(permission => {
                            return permission.menuId == 27
                        });

                        let canOrder = result.data.permissionAndMenu.find(permission => {
                            return permission.menuId == 216 || permission.menuId == 249
                        });

                        if(canOrder != null && result.data.initialPage == 2)
                            this.$router.push('listOrder');
                        else if(canDemands != null || result.data.userData.userType == 2)
                            this.$router.push('kpis');
                        else
                            this.$router.push('menu');
                    }
                    else if(result.status == 401){
                        this.title = "Dados Inválidos";
                        this.message = "Login ou senha inválidos.";
                        this.dialog = true;
                    }
                    else if(result.status == 400){
                        this.title = "Erro";
                        this.message = result.data[0];
                        this.dialog = true;
                    }
                    else if(result.status != 204){
                        this.title = "Erro";
                        this.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
                        this.dialog = true;
                    }

                    loader.hide();
                }
                catch
                {
                    loader.hide();
                    this.title = "Erro";
                    this.message = "Não foi possível conectar. Por favor, verifique sua conexão com a internet e tente novamente mais tarde.";
                    this.dialog = true;
                }
            }  
        },
        back(){
            this.$router.push({name: 'Signature', params: {login: this.$route.params.login}});
        },
        async forgotMyPassword(){
            let loader = this.$loading.show();

            try
            {
                let crudService = new CrudService();

                let loginRequest = {
                    email: this.$route.params.login, 
                    signatureId: this.$route.params.signature,
                };

                let result = await crudService.post(`auth/forgotMyPassword`, loginRequest);
                
                if(result.status == 200 || result.status == 204){
                    this.title = "E-mail enviado";
                    this.message = "A senha foi enviada para o seu email.";
                    this.dialog = true;
                }
                else if(result.status == 401){
                    this.title = "Dados Inválidos";
                    this.message = "Login ou senha inválidos.";
                    this.dialog = true;
                }
                else if(result.status == 400){
                    this.title = "Erro";
                    this.message = result.data[0];
                    this.dialog = true;
                }
                else if(result.status != 204){
                    this.title = "Erro";
                    this.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
                    this.dialog = true;
                }

                loader.hide();
            }
            catch
            {
                loader.hide();
                this.title = "Erro";
                this.message = "Não foi possível conectar. Por favor, verifique sua conexão com a internet e tente novamente mais tarde.";
                this.dialog = true;
            }
        }
    }
}
</script>